<template>
  <v-card>
    <v-toolbar flat color="primary" dark>
      <v-toolbar-title>Context Settings</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="$emit('close')"><v-icon>close</v-icon></v-btn>
    </v-toolbar>
    <v-tabs vertical v-model="tabPage">
      <v-tab>
        Name & Tags
      </v-tab>
      <v-tab>
        Permissions
      </v-tab>
      <v-tab-item>
        <v-card flat>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    autofocus
                    v-model="updateContext.text"
                    label="Context Topic"
                    required
                    @keypress.enter=""
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-toolbar flat dense class="pl-0">
                    <v-toolbar-title class="pl-0">Tags</v-toolbar-title>
                  </v-toolbar>
                  <v-combobox
                    v-model="updateContext.tags"
                    flat
                    :hide-no-data="!search"
                    :items="tags"
                    item-value="id"
                    item-text="text"
                    :search-input.sync="search"
                    hide-selected
                    label="No tags selected"
                    multiple
                    small-chips
                    solo
                    class="px-3"
                  ></v-combobox>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-alert :value="!!error" type="warning">{{ error }}</v-alert>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialog = false">Cancel</v-btn>
            <v-btn color="primary" text @click="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <context-permissions :context="item"></context-permissions>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>

<script>
import ContextPermissions from './ContextPermissions';
export default {
  props: ['item', 'page'],
  components: { ContextPermissions },
  data() {
    return {
      dialog: false,
      error: false,
      tags: [{ id: 1, text: 'Marketing' }],
      search: null,
      tabPage: 0,
      updateContext: {
        text: '',
        tags: []
      }
    };
  },
  mounted() {
    if (this.page) {
      this.tabPage = this.page;
    }
    this.updateContext.text = this.item.text;
    this.updateContext.tags = this.item.tags;
  },
  watch: {
    dialog: function(o, n) {
      console.log(this.dialog);
      if (n) {
        this.updateContext.text = this.item.text;
        this.updateContext.tags = this.item.tags;
      }
    }
  },
  methods: {
    save() {
      // if (!this.workspace.name.length) {
      //   this.error = 'Your workspace needs a name!';
      //   return;
      // }
      // this.$emit('saveName', this.workspace.name);
      // //  close and reset
      // this.dialog = false;
      // this.error = false;
    }
  }
};
</script>
